import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  AfterViewChecked,
  HostListener,
} from '@angular/core';
import {
  ModalController,
  NavController,
  Platform,
  MenuController,
  PopoverController,
} from '@ionic/angular';
import { Location } from '@angular/common';
import {
  CalendarEvent,
  DayViewConfig,
  TimeSlotEvent,
  SMDragEndEvent,
} from './day-view-calendar/day-view-calendar.component';
import { StylistService } from '../../services/stylist.service';
import { CalendarService } from '../../services/calendar.service';
import { Stylist } from '../../models';
import { BackgroundProcessService } from '../../services/background-process.service';
import { OnBoardingService } from '../../services/on-boarding.service';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { Utilities } from '../../utilities/utilities';
import { List } from 'immutable';
import { SubscriptionLike } from 'rxjs';

import { DateRangeSelectorComponent } from '../../components/smr-date-picker/date-range-selector/date-range-selector.component';
import { CalendarSettingsComponent } from './calendar-settings/calendar-settings.component';

@Component({
  selector: 'smr-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit, AfterViewChecked {
  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  @Input() isModal: boolean = false;

  @Input() currentDate: Date;

  @Input() showHeader: boolean;

  @Input() stylistID: number;

  @Input() modal: boolean;

  @Input() hideModalCloseButton: boolean;

  @Input() showStylistPicker: boolean;

  @Input() readOnlyStylistPicker: boolean;

  @Input() showCalendarJumpButton: boolean;

  @Input() muteEventTappability: boolean;

  @Output() onTimeSelected = new EventEmitter<TimeSlotEvent>();

  @Output() onEventSelected = new EventEmitter<CalendarEvent>();

  @Output() onStylistSelect = new EventEmitter<Stylist>();

  @Output() onRangeChanged = new EventEmitter<List<DayViewConfig>>();

  @Output() onEventDragEnd = new EventEmitter<SMDragEndEvent>();

  public stylist: Stylist;

  public stylists: List<Stylist>;

  public isCalendarLoading: boolean = false;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingCalendarEvents: boolean;

  public allStaffViewMode: boolean;

  public views: List<DayViewConfig>;

  public notificationsCount: number;

  public title: string;

  public todaysDate: Date;

  public utilities = Utilities;

  public bookingRequestCount: number = 0;

  public bookingWaitListCount: number = 0;

  public bookingRequestMonitor$: SubscriptionLike;

  public bookingWaitListMonitor$: SubscriptionLike;

  public onboardingMonitor$: SubscriptionLike;

  public firstLoad: boolean = true;

  public isMobile: boolean = false;
  public isMediumScreen: boolean = false;


  public daysToDisplay: number = 1;

  public stylistNum: number;

  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private changeDetectorRef: ChangeDetectorRef,
    private stylistService: StylistService,
    private calendarService: CalendarService,
    public onBoardingService: OnBoardingService,
    private backgroundProcessService: BackgroundProcessService,
    private platform: Platform,
    private menuCtrl: MenuController,


    private location: Location,
    private popoverCtrl: PopoverController
  ) {
    this.stylists = List.of<Stylist>();
    this.views = List.of<DayViewConfig>();

    this.bookingRequestMonitor$ =
      this.backgroundProcessService.bookingRequestMonitor$.subscribe(
        (bookingRequestCount: number) => {
          this.bookingRequestCount = bookingRequestCount;
        }
      );

    this.bookingWaitListMonitor$ =
      this.backgroundProcessService.bookingWaitListMonitor$.subscribe(
        (bookingWaitListCount: number) => {
          this.bookingWaitListCount = bookingWaitListCount;
        }
      );

    if (localStorage.getItem('daysToDisplay')) {
      this.daysToDisplay = parseInt(localStorage.getItem('daysToDisplay'));
    }
  }

  public ngOnInit() {
    this.platform.ready().then(() => {
      const platformWidth: number = this.platform.width();
      if (
        this.platform.is('mobile') ||
        this.platform.is('android') ||
        this.platform.is('iphone') ||
        this.platform.is('mobileweb') || platformWidth < 450
      ) {
        this.isMobile = true;
      } else {
        if (platformWidth < 750) {
          this.isMediumScreen = true;
        }
        this.daysToDisplay = 7;
        this.isMobile = false;
      }

    });
    this.currentDate =
      this.currentDate || this.calendarService.getCalendarDate();
    this.showHeader = this.showHeader === undefined ? true : this.showHeader;
    this.showStylistPicker =
      this.showStylistPicker === undefined ? true : this.showStylistPicker;
    this.readOnlyStylistPicker =
      this.readOnlyStylistPicker === undefined
        ? false
        : this.readOnlyStylistPicker;
    this.showCalendarJumpButton =
      this.showCalendarJumpButton === undefined
        ? true
        : this.showCalendarJumpButton;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.errorOccurredWhileLoadingCalendarEvents = false;
    this.isCalendarLoading = false; // this was previously set to true by default but that was sometimes causing an issue when the smartphone app was reopened
    this.notificationsCount = 0;

    this.stylistService.getStylists().subscribe((stylists: List<Stylist>) => {
      this.stylists = stylists;
    });

    this.onboardingMonitor$ =
      this.onBoardingService.onboardingFinishedMonitor$.subscribe(
        (finished: boolean) => {
          if (finished) {
            this.changeDetectorRef.markForCheck();
          }
        }
      );

    if (localStorage.getItem('allStaffViewMode') && !this.isModal) {
      this.allStaffViewMode =
        localStorage.getItem('allStaffViewMode') == 'true';
    }

    if (this.isModal) {
      this.allStaffViewMode = false;
      this.readOnlyStylistPicker = true;
    }
    // if(localStorage.getItem("allStaffViewMode") && localStorage.getItem("allStaffViewMode") == "true") this.stylistID = 0

    this.stylistService.getStylists().subscribe((stylists) => {
      this.stylistNum = stylists.count();
    });
  }

  public ngAfterViewChecked() {
    this.matchHeights();
  }

  public ngOnDestroy() {
    this.bookingRequestMonitor$.unsubscribe();
    this.bookingWaitListMonitor$.unsubscribe();
    this.onboardingMonitor$.unsubscribe();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenWidth();
  }

  public onTapToReload() {
    this.isCalendarLoading = true;

    if (this.errorOccurredWhileLoadingStylistPicker) {
      this.errorOccurredWhileLoadingStylistPicker = false;
      this.stylistPickerComponent.ngOnInit();
    } else if (this.errorOccurredWhileLoadingCalendarEvents) {
      this.errorOccurredWhileLoadingCalendarEvents = false;
      this.onStylistSelectChange(this.stylist.clone());
    }
  }

  public onEventsBeforeUpdate($event: boolean) {
    if ($event) {
      this.isCalendarLoading = true;
      this.changeDetectorRef.markForCheck();
    }
  }

  public onEventsDidUpdate($event: boolean) {
    if ($event) {
      this.isCalendarLoading = false;
      this.changeDetectorRef.markForCheck();
    }
  }

  public onError() {
    this.isCalendarLoading = false;
    this.errorOccurredWhileLoadingCalendarEvents = true;
    this.changeDetectorRef.markForCheck();
  }

  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.errorOccurredWhileLoadingStylistPicker = false;
      // this.stylist = initResponse.stylist;
      this.onStylistSelectChange(initResponse.stylist);
    } else {
      this.errorOccurredWhileLoadingStylistPicker = true;
      this.isCalendarLoading = false;
      this.changeDetectorRef.markForCheck();
    }
  }

  public onStylistSelectChange(stylist: Stylist) {
    this.isCalendarLoading = true;

    if (this.isModal) {
      this.stylist = stylist;
      this.stylistID = this.stylist.getID();
      return;
    }

    if (!this.firstLoad) {
      if (stylist.getID() === 0) {
        this.allStaffViewMode = true;
        localStorage.setItem('allStaffViewMode', 'true');
      } else {
        this.allStaffViewMode = false;
        localStorage.setItem('allStaffViewMode', 'false');
      }
    } else {
      if (localStorage.getItem('allStaffViewMode') == 'true') {
        stylist = new Stylist({
          id: 0,
          firstName: 'All Staff',
          lastName: '',
          title: '',
          email: undefined,
          phone1: undefined,
          phone2: undefined,
          address1: undefined,
          address2: undefined,
          city: undefined,
          province: undefined,
          postal: undefined,
          country: undefined,
          administrator: undefined,
          isRebook: undefined,
          suggestRebookingBeforeCheckout: undefined,
          stylistKey: undefined,
          confirmApptsManually: undefined,
          calendar: undefined,
          viewAllCalendars: undefined,
          viewAllClients: undefined,
          settingsControl: undefined,
          photoUrl: undefined,
          hideDurations: undefined,
          canPush: undefined,
          cc: undefined,
          allowBookingsUntil: undefined,
          bookingHorizon: undefined,
          sendAppointmentReminderBefore: undefined,
          bookingInterval: undefined,
          letClientsRegister: undefined,
          letClientsCancel: undefined,
          bookingIntro: undefined,
          notifyForAllStaffActivity: undefined,
          newBookingNotification: undefined,
          editBookingNotification: undefined,
          deleteBookingNotification: undefined,
          waitListRequestNotification: undefined,
          serviceDefinitions: undefined,
          areServiceDetailsLoaded: undefined,
          cachedServiceDetailsOptionsEl: undefined,
          intercomUserHash: undefined,
          canViewReports: undefined,
          active: undefined,
          abTest: undefined,
          fbID: undefined,
          cancellationPolicy: undefined,
          waitingList: undefined,
          minCancellation: '',
          letClientsUseFBLogin: undefined,
          allowCancellationUntil: '',
          sort: undefined,
          pronoun: undefined,
          customPronoun: undefined,
          isChatboxEnabled: true,
          isChatBubbleEnabled: true,
        });
      }
    }

    this.firstLoad = false;

    this.stylist = stylist;
    this.stylistID = this.stylist.getID();
    this.onStylistSelect.emit(stylist);
  }

  public switchToAllStaffMode(date: Date) {
    this.currentDate = date;
    this.calendarService.setCalendarDate(this.currentDate);
    const stylist: Stylist = new Stylist({
      id: 0,
      firstName: 'All Staff',
      lastName: '',
      title: '',
      email: undefined,
      phone1: undefined,
      phone2: undefined,
      address1: undefined,
      address2: undefined,
      city: undefined,
      province: undefined,
      postal: undefined,
      country: undefined,
      administrator: undefined,
      isRebook: undefined,
      suggestRebookingBeforeCheckout: undefined,
      stylistKey: undefined,
      confirmApptsManually: undefined,
      calendar: undefined,
      viewAllCalendars: undefined,
      viewAllClients: undefined,
      settingsControl: undefined,
      photoUrl: undefined,
      hideDurations: undefined,
      canPush: undefined,
      cc: undefined,
      allowBookingsUntil: undefined,
      bookingHorizon: undefined,
      sendAppointmentReminderBefore: undefined,
      bookingInterval: undefined,
      letClientsRegister: undefined,
      letClientsCancel: undefined,
      bookingIntro: undefined,
      notifyForAllStaffActivity: undefined,
      newBookingNotification: undefined,
      editBookingNotification: undefined,
      deleteBookingNotification: undefined,
      waitListRequestNotification: undefined,
      serviceDefinitions: undefined,
      areServiceDetailsLoaded: undefined,
      cachedServiceDetailsOptionsEl: undefined,
      intercomUserHash: undefined,
      canViewReports: undefined,
      active: undefined,
      abTest: undefined,
      fbID: undefined,
      cancellationPolicy: undefined,
      waitingList: undefined,
      minCancellation: '',
      letClientsUseFBLogin: undefined,
      allowCancellationUntil: '',
      sort: undefined,
      pronoun: undefined,
      customPronoun: undefined,
      isChatboxEnabled: true,
      isChatBubbleEnabled: true,
    });

    this.onStylistSelectChange(stylist);
  }
  public onViewsChanged(views: List<DayViewConfig>): void {
    this.views = views;
    this.changeDetectorRef.markForCheck();

  }
  public onRangeChangedHandler(views: List<DayViewConfig>) {
    this.views = views;
    this.isCalendarLoading = false;
    this.errorOccurredWhileLoadingCalendarEvents = false;
    this.todaysDate = new Date();
    if (this.views.count() === 1 || this.allStaffViewMode) {
      this.title = Utilities.formatDate(this.currentDate, 'ddd, MMM DD Y');
    } else {
      if (this.isMobile) {
        if (Utilities.areDatesInSameMonth(this.currentDate, this.views.last().date)) {
          // dates in in same month so we can just show one month name
          this.title = `${Utilities.formatDate(
            this.views.get(0).date,
            'MMM Y'
          )}`;
        } else {
          // dates in in different months so we need to show both month names
          this.title = `${Utilities.formatDate(
            this.views.get(0).date,
            "MMM 'YY"
          )} - ${Utilities.formatDate(this.views.last().date, "MMM 'YY")}`;
        }
      } else {
        // desktop view so we can show the full date range information
        this.title = `${Utilities.formatDate(
          this.views.get(0).date,
          'MMM DD Y'
        )} - ${Utilities.formatDate(this.views.last().date, 'MMM DD Y')}`;
      }
    }

    this.onRangeChanged.emit(views);
    this.changeDetectorRef.markForCheck();
  }

  public eventSelectedHandler(event) {
    this.onEventSelected.emit(event);
  }

  public onTimeSelectedHandler(event: TimeSlotEvent) {
    this.onTimeSelected.emit(event);
  }

  public moveCalendarBackwards() {
    this.isCalendarLoading = true;
    if (this.allStaffViewMode) {
      this.currentDate = Utilities.subtractDays(this.currentDate, 1);
    } else {
      this.currentDate = Utilities.subtractDays(
        this.currentDate,
        this.views.count()
      );
    }

    this.calendarService.setCalendarDate(this.currentDate);
  }

  public moveCalendarForward() {
    this.isCalendarLoading = true;
    if (this.allStaffViewMode) {
      this.currentDate = Utilities.addDays(this.currentDate, 1);
    } else {
      this.currentDate = Utilities.addDays(
        this.currentDate,
        this.views.count()
      );
    }

    this.calendarService.setCalendarDate(this.currentDate);
  }

  public onViewNotifications() {
    this.notificationsCount = 0;
    //TODO:ActivityListComponent Modal
    // this.modalCtrl.create("ActivityListPage", {'modal': true}).present();
  }
  public getFontSize(): string {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 510) {
      return '8px';
    }
    if (screenWidth <= 700) {
      return '10px';
    }
    if (screenWidth <= 1146) {
      return '12px';
    }
    // Return default font size if the screen size is outside the specified range
    return 'inherit';
  }
  public async onJumpCalendarDate() {
    const modal = await this.modalCtrl.create({
      component: DateRangeSelectorComponent,
      componentProps: {
        date: this.currentDate,
        pickMode: 'single',
      },
    });

    modal.onDidDismiss().then((response) => {
      if (response.data) {
        if (!this.isSameDate(response.data.date, this.currentDate)) {
          this.isCalendarLoading = true;
          this.currentDate = response.data.date;
          this.calendarService.setCalendarDate(this.currentDate);
          this.changeDetectorRef.markForCheck();
        }
      }
    });

    modal.present();
  }

  public turnOnUniversalSearchMode() {
    //TODO: UniversalSearchComponent Modal
    // const modal = this.modalCtrl.create("UniversalSearchPage");
    // modal.onWillDismiss((client: Client) => {
    //   if (client) {
    //     this.navCtrl.push("ClientDetailPage", {client: client});
    //   }
    // })
    // modal.present();
  }

  public onToday() {
    if (!this.isSameDate(new Date(), this.currentDate)) {
      this.isCalendarLoading = true;
      this.currentDate = new Date();
      this.calendarService.setCalendarDate(this.currentDate);
    }
  }

  public onDismiss() {
    const currentUrl = this.location.path();

    if (currentUrl.includes('/waitlist/waitlist-calendar')) {
      this.location.back();
    } else {
      this.modalCtrl.dismiss();
    }
  }

  public onEventDragEndHandler($event) {
    this.onEventDragEnd.emit($event);
  }

  public onBack() {
    this.navCtrl.pop();
  }

  public isToday(): boolean {
    return Utilities.isEqual(this.currentDate, new Date());
  }

  public selectDate(date) {
    if (!this.isSameDate(date, this.currentDate)) {
      this.isCalendarLoading = true;
      this.currentDate = date;
      this.calendarService.setCalendarDate(date);
    }
  }

  async openMenu() {
    await this.menuCtrl.enable(true);
    this.menuCtrl.toggle();
  }

  public matchHeights() {
    const calHeader = document.getElementsByClassName(
      'smr-calendar-header'
    ) as HTMLCollectionOf<HTMLElement>;
    const calBody = document.getElementsByClassName(
      'smr-calendar-outer'
    ) as HTMLCollectionOf<HTMLElement>;
    calBody[0].style.height = `calc(100% - ${calHeader[0].scrollHeight}px)`;
  }

  public isSameDate(date1, date2) {
    if (date1.getDate() == date2.getDate() && date1.getMonth() == date2.getMonth() && date1.getYear() == date2.getYear())
      return true
    return false
  }

  public async onCalendarSettings(e) {
    const popover = await this.popoverCtrl.create({
      component: CalendarSettingsComponent,
      event: e
    })

    popover.present();

    popover.onDidDismiss().then((data) => {

      if (data.data) {
        this.daysToDisplay = data.data.daysToDisplay;
        this.changeDetectorRef.markForCheck();
      }
    })
  }
  // public adjustWidth(originalWidth: string): string {
  //   // Assuming originalWidth is 'calc(100% - 12px)'
  //   return `calc(${originalWidth} - 8%)`;
  // }
  private checkScreenWidth() {
    const platformWidth: number = window.innerWidth;
    this.isMobile = platformWidth < 450;
    if (platformWidth < 450) {

      this.isMediumScreen = false;
    }
    else if (platformWidth < 750) {

      this.isMediumScreen = true;
    }
    else {
      this.isMediumScreen = false;
    }
  }

}

